import PlatformActions from './PlatformActions'

export default class HABANEROSLOTActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'SLOT',
      gameName: 'Gold Koi Fortune',
      gameCode: 'HABANERO-SLOT-001',
      platform: 'HABANERO',
    }
  }

  getBetNSettleMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      settleTxnId,
      roundId,
      betTime,
      betAmount,
      turnover,
      winAmount,
      jackpotWinAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: settleTxnId, // 5dc3fbe7d16ef11190ec020002002a25
      roundId, // a2c2fbe7-d16e-f111-90ec-020002002a25
      betType: null,
      currency,
      betTime, // 2026-06-23T15:05:24.445+08:00
      txTime: betTime,
      betAmount,
      turnover,
      winAmount,
      jackpotBetAmount: 0,
      jackpotWinAmount: jackpotWinAmount ?? 0,
      updateTime, // 2026-06-23T15:05:25.045+08:00
      requireAmount: betAmount,
      gameInfo: {
        isEndRound: 'true',
      },
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'betNSettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetNSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      settleTxnId,
      roundId,
      betAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: settleTxnId,
      roundId,
      updateTime,
      betAmount,
      gameInfo: {
        isEndRound: 'true',
      },
    }))

    const message = {
      action: 'cancelBetNSettle',
      txns,
    }

    return JSON.stringify(message)
  }
}
